<script setup lang="ts">
interface IdentifierLabelProps {
  label?: string | null;
  identifier?: string | null;
  subline?: string;
  truncate?: boolean;
}

withDefaults(defineProps<IdentifierLabelProps>(), {
  label: null,
  identifier: null,
  subline: undefined,
  truncate: false,
});
</script>

<template>
  <div class="identifier-label" :class="{ 'identifier-label--truncate': truncate }">
    <div
      v-if="subline"
      class="subline text-caption font-weight-medium mb-0"
      data-testid="identifierlabel_subline"
    >
      {{ subline }}
    </div>

    <div class="label-container">
      <span class="label font-weight-bold" data-testid="identifierlabel_label">{{ label }}</span>

      <span v-if="identifier" class="identifier-section"
        >&nbsp;| &#x0020;<span class="identifier" data-testid="identifierlabel_identifier">
          {{ identifier }}
        </span>
      </span>
      <slot name="suffix" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.identifier-label {
  width: 100%;
  max-width: 100%;
  min-width: 0;

  .label-container {
    align-items: center;
    min-width: 0;
    max-width: 100%;

    .label {
      min-width: 0;
      word-break: break-word !important;
      line-height: 1.2;
    }

    .identifier-section {
      margin-left: 4px;
      white-space: nowrap;
      font-weight: 500;

      .identifier {
        white-space: nowrap;
      }
    }
  }

  // Truncation styles
  &.identifier-label--truncate {
    overflow: hidden;

    .label-container {
      display: flex;
      flex-wrap: nowrap;

      .label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: normal;
        line-height: normal;
      }
    }
  }
}
</style>
